import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../config';

const Admin = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [bookings, setBookings] = useState([]);
    const [calendarEvents, setCalendarEvents] = useState([]);
    const [calendarDate, setCalendarDate] = useState(new Date().toISOString().split('T')[0]);
    const [calendarLoading, setCalendarLoading] = useState(false);
    const [calendarError, setCalendarError] = useState('');

    // Controlla se l'autenticazione è completata
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get('auth') === 'success') {
            setIsAuthenticated(true);
            // Rimuovi il parametro dall'URL
            window.history.replaceState({}, '', '/admin');
        }
    }, []);

    // Connetti Google Calendar
    const handleGoogleAuth = () => {
        // Salva l'URL corrente per il redirect dopo auth
        sessionStorage.setItem('returnUrl', window.location.href);
        
        // Redirect al backend per OAuth
        window.location.href = `${API_BASE_URL}/api/google/oauth`;
    };

    // Carica prenotazioni
    const fetchBookings = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/bookings`);
            const data = await response.json();
            
            if (data.success) {
                setBookings(data.data);
            }
        } catch (error) {
            console.error('Errore caricamento prenotazioni:', error);
        }
    };

    const fetchCalendar = async (date = calendarDate) => {
        setCalendarLoading(true);
        setCalendarError('');
        try {
            const response = await fetch(`${API_BASE_URL}/api/bookings/calendar?date=${date}&days=1`);
            const data = await response.json();

            if (!response.ok || !data.success) {
                throw new Error(data.message || data.error || 'Errore caricamento calendario');
            }

            setCalendarEvents(data.events || []);
        } catch (error) {
            console.error('Errore calendario:', error);
            setCalendarError(error.message);
            setCalendarEvents([]);
        } finally {
            setCalendarLoading(false);
        }
    };

    useEffect(() => {
        if (isAuthenticated) {
            fetchBookings();
            fetchCalendar();

            const id = setInterval(() => {
                fetchCalendar();
            }, 30000);

            return () => clearInterval(id);
        }
    }, [isAuthenticated]);

    return (
        <div className="admin-container">
            <h1>Area Admin</h1>
            
            {!isAuthenticated ? (
                <div className="auth-section">
                    <h2>Connetti Google Calendar</h2>
                    <button onClick={handleGoogleAuth} className="google-btn">
                        🔗 Autorizza Google Calendar
                    </button>
                </div>
            ) : (
                <div className="bookings-section">
                    <h2>Prenotazioni</h2>
                    <button onClick={fetchBookings} className="refresh-btn">
                        🔄 Aggiorna
                    </button>
                    
                    {bookings.length === 0 ? (
                        <p>Nessuna prenotazione</p>
                    ) : (
                        <table>
                            <thead>
                                <tr>
                                    <th>Cliente</th>
                                    <th>Data</th>
                                    <th>Ora</th>
                                    <th>Ospiti</th>
                                    <th>Stato</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookings.map(booking => (
                                    <tr key={booking.id}>
                                        <td>{booking.customer_name}</td>
                                        <td>{booking.booking_date}</td>
                                        <td>{booking.booking_time}</td>
                                        <td>{booking.number_of_guests}</td>
                                        <td>{booking.status}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    <div className="calendar-section">
                        <div className="calendar-header">
                            <h2>Calendario prenotazioni</h2>
                            <div className="calendar-controls">
                                <input
                                    type="date"
                                    value={calendarDate}
                                    onChange={(e) => {
                                        setCalendarDate(e.target.value);
                                        fetchCalendar(e.target.value);
                                    }}
                                />
                                <button onClick={() => fetchCalendar()} className="refresh-btn">
                                    🔁 Aggiorna calendario
                                </button>
                            </div>
                        </div>

                        {calendarLoading && <p>Carico il calendario...</p>}
                        {calendarError && <p className="error">❌ {calendarError}</p>}

                        {!calendarLoading && !calendarError && (
                            calendarEvents.length === 0 ? (
                                <p>Nessun evento per questa data.</p>
                            ) : (
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Ora</th>
                                            <th>Evento</th>
                                            <th>Ospiti</th>
                                            <th>Email</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {calendarEvents.map(event => {
                                            const start = event.start ? new Date(event.start) : null;
                                            const end = event.end ? new Date(event.end) : null;
                                            const timeLabel = start && end
                                                ? `${start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
                                                : 'N/D';

                                            return (
                                                <tr key={event.id}>
                                                    <td>{timeLabel}</td>
                                                    <td>{event.summary || 'Prenotazione'}</td>
                                                    <td>{event.guests || '-'}</td>
                                                    <td>{(event.attendees && event.attendees[0]) || '-'}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            )
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Admin;